module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "web-mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "web"
  }, [_c('div', {
    staticClass: "web-head"
  }, [_vm._v("\n      " + _vm._s(this.$store.state.drug.selectedDrug.generic_name) + "\n      "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.prefixSet) ? _c('iframe', {
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  }) : _c('div', {
    staticClass: "with-child-centered",
    staticStyle: {
      "width": "1000px",
      "height": "600px"
    }
  }, [_vm._v("未設定外部網址")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93b00adc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/DrugInfoWeb.vue
// module id = 1525
// module chunks = 1